import http from '../plugins/utils/http'
let api = '/api'
const dictionary = {
    dictCommonSelect(params) {
        return http.get(`${api}/app-jycy-sysdict/commonDictValue?dictCode`, params)
    },
}
export default dictionary